import { Flex, Image } from "antd";
import { Fade } from "react-awesome-reveal";
import img from "../images/medetkhan.jpeg";
import MyText from "../../../components/UI/Text/MyText";
import { clrs } from "../../../constants/colors";
import HorizontalDivider from "../../../components/Divider/HorizontalDivider";
import { Link } from "react-router-dom";
import { LinkOutlined } from "@ant-design/icons";
import React from "react";

export const PersonMedetkhan = () => {
    return (
        <Flex style={{ width: "100%", position: "relative" }} vertical gap={20}>
            <Flex style={{ width: "100%", position: "relative" }} gap={40} wrap="wrap">
                <Fade triggerOnce={true} cascade damping={0.15}>
                    <Image src={img} width={240} preview={false} style={{ borderRadius: 16 }} />
                </Fade>
                <Flex style={{ flex: 1, minWidth: 200, position: "relative" }} vertical>
                    <MyText strong size={"large"}>Медетхан Айнур Сейтжанкызы</MyText>
                    <MyText style={{ color: clrs.whiterBlacker }}>
                        Магистр технических наук
                    </MyText>
                    <br />
                    <HorizontalDivider />
                    <br />
                    <Flex gap={12} wrap={"wrap"} vertical>
                        <Link target={"_blank"} to={'https://orcid.org/0009-0003-3539-6930'}>
                            <MyText><LinkOutlined /> ORCID</MyText>
                        </Link>
                        <Link target={"_blank"} to={'https://www.webofscience.com/wos/author/record/MCI-5910-2025'}>
                            <MyText><LinkOutlined /> Web of Science (ResearcherID MCI-5910-2025)</MyText>
                        </Link>
                    </Flex>
                    <br />
                    <MyText strong size={"small"}>Основное место работы, должность</MyText>
                    <MyText>ТОО «Astana IT University», младший научный сотрудник центра «Industry 4.0». Опыт по профилю — 2 года.</MyText>
                </Flex>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Роль в проекте</MyText>
                <MyText size={"small"} italic>Младший научный сотрудник (исполнитель)</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Разработка и применение геоинформационных моделей для оценки, анализа и прогноза водных ресурсов WEAP Жамбылской области;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Пространственный анализ в QGIS и ArcGIS;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Совместное проведение экспериментальных исследований и написание научных статей.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Краткое обоснование участия</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    Специалист в области энергетики и моделирования систем. В 2021 г. окончила ЕНУ им. Л.Н. Гумилева по специальности «Теплоэнергетика», в 2024 г. — магистратура по программе М098 «Теплоэнергетика». Прошла научную стажировку в АУЭС им. Г. Даукеева. Навыки: MatLab, WEAP, QGIS, ArcGIS, AutoCAD.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Научные проекты:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - AP23490690 «Моделирование топливно-энергетического баланса Казахстана (KZLEAP)», исполнитель.
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - BR21882258 «Экологический мониторинг эмиссий», исполнитель.
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - BR24993128 «ИАС трансграничных водных ресурсов» (2024-2026), исполнитель.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Публикации:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    1. Biloshchytskyi, Neftissov, Kazambayev, Amangeldi, Kirichenko, Medetkhan. Correlation-Matrix-Driven Diagnostics of Industrial Emissions: A Pearson Baseline with Scatter-Plot Evidence. Scientific Journal of Astana IT University, 24, 2025.
                </MyText>
            </Flex>
        </Flex>
    );
};
